import { Button } from '@radix-ui/themes';
import { SimpleCv } from '../types';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

export function DownloadSimpleCvPdf({ simpleCv }: { simpleCv: SimpleCv }) {
   return (
      <Button size="4" radius="small">
         <FileDownloadOutlinedIcon />
         Завантажити PDF
      </Button>
   );
}
